<template>

    <div class="match-list">
      <SVGS></SVGS>
        <div class="status-tabs">
          <div :class=" tab==='next' ? 'text-color border-color active':''" v-on:click="changeTab('next')"><span class="tab-icon calendar-tab-icon"><svg :class=" tab==='next' ? 'fill-color':'not-active'"><use xlink:href="#calendar" /></svg></span> <span class="tab-text">Calendário</span> </div>
            <div :class=" tab==='prev' ? 'text-color border-color active':''" v-on:click="changeTab('prev')"><span class="tab-icon squares-tab-icon"><svg :class=" tab==='prev' ? 'fill-color':'not-active'"><use xlink:href="#squares" /></svg></span> <span class="tab-text">Resultados</span> </div>
        </div>

        <router-link :to="{name:'match',params:{id:match.id}}" v-for="match in matchList" class="single-match" :class="match.status==='live' ? 'live' : ''" :key="match.id">
                <div class="left-team team">

                  <div class="team-logo">
                    <img :src="$urlOrDefault(match.teams_formatted['home']['team']['logo_picture'],'logo')">
                  </div>

                  <div class="team-name text-left">
                    {{ match.teams_formatted['home']['data']['name'] }}
                  </div>



                </div>
                <div class="center">
                  <span class="live-label" v-if="match.status==='live'">live</span>

                  <template v-if="match.status==='finished'">

                    <template v-if="match.teams_formatted['home']['data']['score'] < match.teams_formatted['away']['data']['score']">
                      <span class="looser-color">{{ match.teams_formatted['home']['data']['score'] }}</span> : <span class="winner-color">{{ match.teams_formatted['away']['data']['score'] }}</span>
                    </template>

                    <template v-if="match.teams_formatted['home']['data']['score'] > match.teams_formatted['away']['data']['score']">
                      <span class="winner-color">{{ match.teams_formatted['home']['data']['score'] }}</span> : <span class="looser-color">{{ match.teams_formatted['away']['data']['score'] }}</span>
                    </template>

                    <template v-if="match.teams_formatted['home']['data']['score'] === match.teams_formatted['away']['data']['score']">
                      <span class="draw-color">{{ match.teams_formatted['home']['data']['score'] }}</span> : <span class="draw">{{ match.teams_formatted['away']['data']['score'] }}</span>
                    </template>


                  </template>

                  <template v-if="match.status==='comingup'">
                    {{ generateDateFormated(match.date_time_jogo) }}
                  </template>

                </div>
                <div class="right-team team">

                  <div class="team-name text-right">
                    {{ match.teams_formatted['away']['data']['name'] }}
                  </div>
                  <div class="team-logo">
                    <img :src="$urlOrDefault(match.teams_formatted['away']['team']['logo_picture'],'logo')">
                  </div>
                </div>
        </router-link>

        <p v-if="matchList==null || matchList.length<=0" class="text-white">Sem jogos</p>

    </div>


</template>

<script>
    import MatchRepository from "../../api/MatchRepository";
    import Funcs from "../../functions";
    import SVGS from "@/components/SVGS";

    export default {
        name: "MatchList",
      components: {SVGS},
      props: {
            tournament_id: Number,
            amount: Number,
            staticLinks: Boolean
        },
        data: function(){
            return {
                matchPrev:null,
                matchNext:null,
                status:'comingup,live',
                tab:'next',
                isLoading:true
            }
        },
        computed: {
          matchList: function(){

              if(this.tab==='next'){
                  return this.matchNext;
              } else {
                  return this.matchPrev;
              }

          }
        },
        created: function(){
            this.getData();
        },
        methods: {
            async getData(){

                let params={status:this.status};

                if(this.$props.tournament_id){
                    params['tournament_id']=this.$props.tournament_id;
                }

                if(this.$props.amount){
                    params['amount']=this.$props.amount;
                }

                const { data } = await MatchRepository.get(params);

                if(this.status==="comingup,live"){
                    this.matchNext=data.data;
                } else {
                    this.matchPrev=data.data;
                }

                if(this.matchNext.length===0){
                  this.changeTab('prev');
                }

                this.isLoading=false;

            },
            changeTab(newtab){

                if(newtab==='next'){

                    this.tab='next';

                } else if(newtab==='prev'){

                    if(this.matchPrev === null){

                        this.status="finished";
                        this.getData();

                    }

                    this.tab='prev';
                }
            },
            generateDateFormated(date){
                return Funcs.formatDate(date);
            }
        }
    }
</script>

<style scoped>

    .match-list {
        width: 100%;
        background: #141F26;
    }

    .match-list > .single-match {
        height: 38px;
        line-height: 38px;
        padding-left: 10px;
        padding-right: 10px;
    }

    .match-list > .single-match:not(:first-child){
        margin-top:1px;
    }

    .match-list > .single-match:nth-child(even){
        background-color: rgba(10, 21, 28, 0.50);
    }

    .match-list > .single-match {
        display: flex;
    }

    .match-list > .single-match.live {
        background: rgba(40, 51, 58, 0.5);
    }

    .match-list > .single-match > .team {
        width: 38%;
        height: 100%;
        text-align: left;
    }
    .match-list > .single-match > .team > .team-logo {
        width: 20%;
    }

    .match-list > .single-match > .team > .team-name {
        line-height: 40px;
        height: 100%;
        width: 78%;
        color:#78838A;
        font-size: 12px;
        overflow: hidden; /* make sure it hides the content that overflows */
        white-space: nowrap; /* don't break the line */
        text-overflow: ellipsis; /* give the beautiful '...' effect */
    }

    .match-list > .single-match > .left-team > .team-name {
        float:right;
    }

    .match-list > .single-match > .right-team > .team-name {
        float:left;
    }

    .match-list > .single-match > .left-team > .team-logo {
        float:left;
    }

    .match-list > .single-match > .right-team > .team-logo {
        float:right;
    }

    .match-list > .single-match > .center {
        width: 24%;
        height: 100%;
        text-align: center;
        color: #FFFFFF;
        font-size:12px;
    }

    .match-list > .single-match > .center > .live-label {
        background: #EA5455;
        border-radius: 1px;
        font-weight: bold;
        font-size: 10px;
        padding: 3px 15px;
        text-transform: uppercase;
    }

    .match-list > .single-match > .team > .team-logo > img {
        max-height: 20px;
        vertical-align: middle;
    }

    .match-list > .single-match > .right-team{
        text-align: right;
    }

    .single-match:hover,.center:hover {
      text-decoration: none;
    }

    .status-tabs {
        display: flex;
        height:40px;
        text-align: center;
        font-weight: bold;
        text-transform: uppercase;
        font-size:14px;
        line-height: 40px;
        margin-top: 20px;
    }

    .status-tabs > div {
        flex:1;
        text-align: center;
        border-top: 1px solid #28333A;
        cursor:pointer;
    }

    .status-tabs > div.active {
        background-color: rgba(15, 26, 33, 0.5);
    }

    .tab-icon,
    .tab-text {
      vertical-align: middle;
      display: inline-block;
    }

    .tab-icon {
      margin-right: 5px;
    }

    .calendar-tab-icon > svg {
      width: 13px;
      height: 13px;
    }

    .squares-tab-icon > svg {
      padding-top: 5px;
      width: 15px;
      height: 15px;
    }

    .not-active {
      fill:#2C3E50;
    }
</style>
<style>
.cont {
  background-color: #141F26;
}
</style>